import { Link } from "react-router-dom";
import { FileText, ChevronLeft } from "lucide-react";

export default function LegalNoticePage() {
  return (
    <div className="py-12 sm:py-16" data-testid="legal-notice-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <Link to="/" className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-700 mb-6 transition-colors">
          <ChevronLeft className="w-3 h-3" /> Volver al inicio
        </Link>

        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 bg-slate-900 rounded-sm flex items-center justify-center">
            <FileText className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="heading-industrial text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase tracking-tight" data-testid="legal-notice-title">
              Aviso Legal
            </h1>
            <p className="text-xs text-slate-400 uppercase tracking-wider mt-0.5">Condiciones generales de uso</p>
          </div>
        </div>

        {/* 1. Datos identificativos */}
        <Section title="1. Datos identificativos del titular">
          <div className="bg-slate-50 border border-slate-200 rounded-sm p-5">
            <div className="space-y-1.5 text-sm text-slate-600">
              <Row label="Razon social" value="Ascauto, S.A." />
              <Row label="CIF" value="A79668307" />
              <Row label="Domicilio social" value="C. de Simón Hernández, 71, 28937 Móstoles, Madrid, España" />
              <Row label="Actividad" value="Concesionario y taller oficial Stellantis. Venta, reparacion y mantenimiento de vehiculos de las marcas Fiat, Abarth, Alfa Romeo, Jeep, Opel, Leapmotor y Fiat Professional." />
              <Row label="Telefono" value="916 003 800" />
              <Row label="Email general" value={<a href="mailto:ascauto@ascauto.com" className="text-red-600 underline hover:text-red-700">ascauto@ascauto.com</a>} />
              <Row label="Email proteccion de datos" value={<a href="mailto:RGPD@ascauto.com" className="text-red-600 underline hover:text-red-700">RGPD@ascauto.com</a>} />
              <Row label="Sitio web" value={<a href="https://ascauto.com" target="_blank" rel="noopener noreferrer" className="text-red-600 underline hover:text-red-700">ascauto.com</a>} />
              <Row label="Registro mercantil" value="Inscrita en el Registro Mercantil de Madrid" />
            </div>
          </div>
        </Section>

        {/* 2. Objeto */}
        <Section title="2. Objeto y ambito de aplicacion">
          <p className="text-sm text-slate-600 leading-relaxed">
            El presente Aviso Legal regula el acceso y la utilizacion del sitio web de Ascauto, S.A. (en adelante, "el sitio web"). El acceso al sitio web atribuye la condicion de usuario e implica la aceptacion plena y sin reservas de todas las disposiciones incluidas en este Aviso Legal, asi como en la <Link to="/politica-de-privacidad" className="text-red-600 underline hover:text-red-700">Politica de Privacidad</Link> y la <Link to="/politica-de-cookies" className="text-red-600 underline hover:text-red-700">Politica de Cookies</Link>.
          </p>
          <p className="text-sm text-slate-600 leading-relaxed mt-2">
            Ascauto se reserva el derecho a modificar, en cualquier momento y sin previo aviso, la presentacion, configuracion y contenidos del sitio web, asi como las condiciones de acceso.
          </p>
        </Section>

        {/* 3. Condiciones de uso */}
        <Section title="3. Condiciones de uso">
          <p className="text-sm text-slate-600 leading-relaxed mb-2">
            El usuario se compromete a utilizar el sitio web y sus servicios de forma diligente, correcta y licita, y en particular se obliga a abstenerse de:
          </p>
          <ul className="list-disc list-inside text-sm text-slate-600 space-y-1.5 ml-2">
            <li>Utilizar los contenidos y servicios con fines ilicitos, contrarios al orden publico o a la buena fe.</li>
            <li>Reproducir, copiar, distribuir, transformar, modificar o comunicar publicamente los contenidos del sitio web sin autorizacion expresa.</li>
            <li>Introducir o difundir virus informaticos, gusanos, troyanos o cualquier otro software o hardware destinado a causar danos.</li>
            <li>Intentar acceder, utilizar o manipular los datos de terceros usuarios, servidores o cuentas de correo electronico.</li>
            <li>Suprimir, alterar, eludir o manipular cualquier dispositivo de proteccion o sistema de seguridad del sitio web.</li>
            <li>Utilizar herramientas de scraping, bots u otros medios automatizados para acceder de forma masiva al sitio web sin autorizacion previa.</li>
          </ul>
          <p className="text-sm text-slate-600 leading-relaxed mt-2">
            Ascauto podra adoptar las medidas legales y tecnicas que considere oportunas para prevenir o corregir cualquier uso indebido del sitio web.
          </p>
        </Section>

        {/* 4. Propiedad intelectual */}
        <Section title="4. Propiedad intelectual e industrial">
          <p className="text-sm text-slate-600 leading-relaxed">
            Todos los contenidos del sitio web, incluyendo a titulo enunciativo y no limitativo textos, fotografias, graficos, imagenes, logotipos, iconos, marcas, nombres comerciales, software, bases de datos, diseno y estructura de navegacion, estan protegidos por las leyes de propiedad intelectual e industrial y son titularidad de Ascauto, S.A. o de sus licenciantes (incluidas las marcas Stellantis).
          </p>
          <p className="text-sm text-slate-600 leading-relaxed mt-2">
            Queda expresamente prohibida la reproduccion total o parcial, distribucion, comunicacion publica, transformacion o cualquier otra forma de explotacion de estos contenidos sin la autorizacion previa y por escrito de Ascauto, S.A. Las marcas Fiat, Abarth, Alfa Romeo, Jeep, Opel, Leapmotor y Fiat Professional son propiedad de Stellantis N.V. y se utilizan bajo licencia.
          </p>
        </Section>

        {/* 5. Responsabilidad */}
        <Section title="5. Limitacion de responsabilidad">
          <p className="text-sm text-slate-600 leading-relaxed mb-2">Ascauto no sera responsable de:</p>
          <ul className="list-disc list-inside text-sm text-slate-600 space-y-1.5 ml-2">
            <li>Errores u omisiones en los contenidos del sitio web, ni de la falta de disponibilidad del mismo por razones tecnicas, mantenimiento o causas de fuerza mayor.</li>
            <li>Danos o perjuicios que se deriven del acceso o uso indebido del sitio web por parte de los usuarios.</li>
            <li>La presencia de virus o programas daninos en los contenidos que puedan causar alteraciones en los sistemas informaticos.</li>
            <li>Contenidos de sitios web de terceros a los que se pueda acceder mediante enlaces desde este sitio web.</li>
          </ul>
          <p className="text-sm text-slate-600 leading-relaxed mt-2">
            La informacion sobre precios, disponibilidad de vehiculos, horarios y servicios tiene caracter informativo y puede no estar actualizada en tiempo real. Consulta con nuestro equipo para confirmar cualquier dato.
          </p>
        </Section>

        {/* 6. Enlaces */}
        <Section title="6. Politica de enlaces">
          <p className="text-sm text-slate-600 leading-relaxed">
            El sitio web puede contener enlaces a paginas de terceros. Ascauto no se hace responsable del contenido, politicas de privacidad ni practicas de dichos sitios. El acceso a traves de enlaces se realiza bajo la exclusiva responsabilidad del usuario.
          </p>
        </Section>

        {/* 7. Proteccion de datos */}
        <Section title="7. Proteccion de datos personales">
          <p className="text-sm text-slate-600 leading-relaxed">
            El tratamiento de los datos personales de los usuarios se rige por nuestra{" "}
            <Link to="/politica-de-privacidad" className="text-red-600 underline hover:text-red-700 font-medium">Politica de Privacidad</Link>, que forma parte integrante del presente Aviso Legal. Te recomendamos su lectura antes de facilitar tus datos a traves de cualquiera de los formularios del sitio web.
          </p>
        </Section>

        {/* 8. Legislacion */}
        <Section title="8. Legislacion aplicable y jurisdiccion">
          <p className="text-sm text-slate-600 leading-relaxed">
            Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia que pudiera derivarse del acceso o uso del sitio web, las partes se someten, con renuncia expresa a cualquier otro fuero, a la jurisdicción de los Juzgados y Tribunales de Móstoles (Madrid), salvo que la legislación aplicable establezca un fuero imperativo distinto en favor del consumidor.
          </p>
        </Section>

        <p className="text-xs text-slate-400 text-center mt-10 pt-6 border-t border-slate-100">Ultima actualizacion: febrero 2026 | Ascauto, S.A. | CIF A79668307</p>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="mb-8">
      <h2 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-3 pb-2 border-b border-slate-200">{title}</h2>
      <div>{children}</div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex flex-col sm:flex-row sm:gap-2 py-1.5 text-sm border-b border-slate-50 last:border-0">
      <span className="font-semibold text-slate-800 sm:w-48 flex-shrink-0">{label}:</span>
      <span className="text-slate-600">{value}</span>
    </div>
  );
}
